module.exports = __webpack_public_path__ + "img/reverse_right.56ee1216.jpg";